import { Link, useLocation } from "react-router-dom";
import { InstaPassLogo } from "../Components/layout/Components/InstaPassLogo";

/* ─────────────────────────────────────────────────────────────
   OLD STUB CONTENT — commented out, preserved for reference
   ─────────────────────────────────────────────────────────────

const COPY = {
  "/qr-studio/create": {
    title: "QR Code Generator",
    subtitle:
      "The full generator workspace from the design system is not bundled in this client yet. Use QR Studio overview for branded previews, or open the new-ui dev app for the complete tool.",
  },
  "/qr-studio/library": {
    title: "My QR Codes",
    subtitle: "Library view is coming soon in this client build.",
  },
  "/qr-studio/analytics": {
    title: "Analytics",
    subtitle: "Analytics dashboard is coming soon in this client build.",
  },
  "/qr-studio/templates": {
    title: "Templates",
    subtitle: "Templates gallery is coming soon in this client build.",
  },
};

export default function QRStudioToolStub() {
  const { pathname } = useLocation();
  const { title, subtitle } = COPY[pathname] || {
    title: "QR Code Studio",
    subtitle: "This section is not available yet.",
  };

  return (
    <div
      className="min-h-screen bg-[#0B0F19] text-white"
      style={{ fontFamily: "'Inter', sans-serif" }}
    >
      <header className="h-[64px] bg-[#0B0F19]/80 backdrop-blur-xl border-b border-white/[0.04] flex items-center justify-between px-6 lg:px-10 sticky top-0 z-50">
        <div className="flex items-center gap-5">
          <Link to="/" className="shrink-0">
            <InstaPassLogo size="sm" />
          </Link>
          <div className="hidden sm:flex items-center gap-1.5">
            <span className="text-white/10">|</span>
            <span
              className="text-[13px] text-white/50"
              style={{ fontWeight: 600, fontFamily: "'Outfit', sans-serif" }}
            >
              QR Code Studio
            </span>
          </div>
        </div>
        <Link
          to="/qr-studio"
          className="text-[12px] text-[#E52324] hover:text-[#FF4444] transition-colors"
          style={{ fontWeight: 600 }}
        >
          ← Overview
        </Link>
      </header>
      <div className="max-w-lg mx-auto px-6 py-24 text-center">
        <h1
          className="text-[28px] text-white mb-3"
          style={{ fontWeight: 800, fontFamily: "'Outfit', sans-serif" }}
        >
          {title}
        </h1>
        <p className="text-[14px] text-white/35 leading-relaxed mb-10">{subtitle}</p>
        <Link
          to="/qr-studio"
          className="inline-flex items-center gap-2 px-8 py-3.5 rounded-2xl text-[13px] text-white transition-all hover:brightness-110"
          style={{
            fontWeight: 800,
            background: "linear-gradient(135deg, #E52324, #C41E1E)",
            boxShadow: "0 8px 30px #E5232425",
          }}
        >
          Back to QR Studio
        </Link>
      </div>
    </div>
  );
}

   ───────────────────────────────────────────────────────────── */

// ─── PAGE LABELS ────────────────────────────────────────────
const PAGE_LABELS = {
  "/qr-studio/create":    "QR Code Generator",
  "/qr-studio/library":   "My QR Codes",
  "/qr-studio/analytics": "Analytics",
  "/qr-studio/templates": "Templates",
};

// ─── INLINE STYLES (no Tailwind dependency for animations) ──
const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@400;600;700;800;900&family=Inter:wght@400;500;600&display=swap');

  @keyframes qs-float {
    0%, 100% { transform: translateY(0px) rotate(0deg); }
    33%       { transform: translateY(-14px) rotate(1.5deg); }
    66%       { transform: translateY(-7px) rotate(-1deg); }
  }
  @keyframes qs-pulse-ring {
    0%   { transform: scale(0.8); opacity: 0.6; }
    100% { transform: scale(1.6); opacity: 0; }
  }
  @keyframes qs-shimmer {
    0%   { background-position: -200% center; }
    100% { background-position: 200% center; }
  }
  @keyframes qs-fade-up {
    from { opacity: 0; transform: translateY(24px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  @keyframes qs-spin-slow {
    from { transform: rotate(0deg); }
    to   { transform: rotate(360deg); }
  }
  @keyframes qs-dot-bounce {
    0%, 80%, 100% { transform: scale(0.6); opacity: 0.4; }
    40%           { transform: scale(1);   opacity: 1;   }
  }

  .qs-float       { animation: qs-float 6s ease-in-out infinite; }
  .qs-pulse-ring  { animation: qs-pulse-ring 2s ease-out infinite; }
  .qs-fade-up-1   { animation: qs-fade-up 0.6s ease forwards 0.1s; opacity: 0; }
  .qs-fade-up-2   { animation: qs-fade-up 0.6s ease forwards 0.3s; opacity: 0; }
  .qs-fade-up-3   { animation: qs-fade-up 0.6s ease forwards 0.5s; opacity: 0; }
  .qs-fade-up-4   { animation: qs-fade-up 0.6s ease forwards 0.7s; opacity: 0; }

  .qs-shimmer-text {
    background: linear-gradient(
      90deg,
      #E52324 0%,
      #FF6B6B 30%,
      #ffffff 50%,
      #FF6B6B 70%,
      #E52324 100%
    );
    background-size: 200% auto;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    animation: qs-shimmer 3s linear infinite;
  }

  .qs-spin-slow { animation: qs-spin-slow 12s linear infinite; }

  .qs-dot { animation: qs-dot-bounce 1.4s ease-in-out infinite; }
  .qs-dot:nth-child(2) { animation-delay: 0.2s; }
  .qs-dot:nth-child(3) { animation-delay: 0.4s; }

  .qs-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 16px 48px rgba(229,35,36,0.45) !important;
  }
  .qs-btn { transition: transform 0.25s ease, box-shadow 0.25s ease; }

  .qs-badge:hover { background: rgba(229,35,36,0.18); }
  .qs-badge { transition: background 0.2s ease; }
`;

// ─── QR ICON (inline SVG, no external dep) ──────────────────
function QRIcon() {
  return (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* top-left block */}
      <rect x="4"  y="4"  width="24" height="24" rx="4" fill="#E52324" opacity="0.15"/>
      <rect x="8"  y="8"  width="16" height="16" rx="2" fill="#E52324" opacity="0.6"/>
      <rect x="12" y="12" width="8"  height="8"  rx="1" fill="#E52324"/>
      {/* top-right block */}
      <rect x="36" y="4"  width="24" height="24" rx="4" fill="#E52324" opacity="0.15"/>
      <rect x="40" y="8"  width="16" height="16" rx="2" fill="#E52324" opacity="0.6"/>
      <rect x="44" y="12" width="8"  height="8"  rx="1" fill="#E52324"/>
      {/* bottom-left block */}
      <rect x="4"  y="36" width="24" height="24" rx="4" fill="#E52324" opacity="0.15"/>
      <rect x="8"  y="40" width="16" height="16" rx="2" fill="#E52324" opacity="0.6"/>
      <rect x="12" y="44" width="8"  height="8"  rx="1" fill="#E52324"/>
      {/* data dots */}
      <rect x="36" y="36" width="6" height="6" rx="1" fill="#E52324" opacity="0.7"/>
      <rect x="44" y="36" width="6" height="6" rx="1" fill="#E52324" opacity="0.4"/>
      <rect x="52" y="36" width="6" height="6" rx="1" fill="#E52324" opacity="0.9"/>
      <rect x="36" y="44" width="6" height="6" rx="1" fill="#E52324" opacity="0.5"/>
      <rect x="44" y="44" width="6" height="6" rx="1" fill="#E52324"/>
      <rect x="52" y="44" width="6" height="6" rx="1" fill="#E52324" opacity="0.3"/>
      <rect x="36" y="52" width="6" height="6" rx="1" fill="#E52324" opacity="0.8"/>
      <rect x="44" y="52" width="6" height="6" rx="1" fill="#E52324" opacity="0.2"/>
      <rect x="52" y="52" width="6" height="6" rx="1" fill="#E52324" opacity="0.6"/>
    </svg>
  );
}

// ─── MAIN COMPONENT ─────────────────────────────────────────
export default function QRStudioToolStub() {
  const { pathname } = useLocation();
  const pageTitle = PAGE_LABELS[pathname] || "QR Code Studio";

  return (
    <>
      <style>{styles}</style>

      <div
        style={{
          minHeight: "100vh",
          background: "#0B0F19",
          color: "#fff",
          fontFamily: "'Inter', sans-serif",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* ── Background radial glows ── */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            background:
              "radial-gradient(ellipse 60% 50% at 50% -10%, rgba(229,35,36,0.12) 0%, transparent 70%)," +
              "radial-gradient(ellipse 40% 40% at 80% 80%, rgba(229,35,36,0.06) 0%, transparent 60%)",
            pointerEvents: "none",
          }}
        />

        {/* ── Subtle grid overlay ── */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundImage:
              "linear-gradient(rgba(255,255,255,0.022) 1px, transparent 1px)," +
              "linear-gradient(90deg, rgba(255,255,255,0.022) 1px, transparent 1px)",
            backgroundSize: "48px 48px",
            pointerEvents: "none",
          }}
        />

        {/* ── Header ── */}
        <header
          style={{
            height: 64,
            background: "rgba(11,15,25,0.8)",
            backdropFilter: "blur(20px)",
            borderBottom: "1px solid rgba(255,255,255,0.04)",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "0 40px",
            position: "sticky",
            top: 0,
            zIndex: 50,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
            <Link to="/" style={{ flexShrink: 0 }}>
              <InstaPassLogo size="sm" />
            </Link>
            <span style={{ color: "rgba(255,255,255,0.08)", fontSize: 13 }}>|</span>
            <span
              style={{
                fontSize: 13,
                fontWeight: 600,
                fontFamily: "'Outfit', sans-serif",
                color: "rgba(255,255,255,0.45)",
              }}
            >
              QR Code Studio
            </span>
          </div>

          <Link
            to="/qr-studio"
            style={{
              fontSize: 12,
              fontWeight: 600,
              color: "#E52324",
              textDecoration: "none",
              transition: "color 0.2s",
            }}
            onMouseEnter={e => (e.currentTarget.style.color = "#FF5555")}
            onMouseLeave={e => (e.currentTarget.style.color = "#E52324")}
          >
            ← Overview
          </Link>
        </header>

        {/* ── Main content ── */}
        <main
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "calc(100vh - 64px)",
            padding: "60px 24px",
            textAlign: "center",
            position: "relative",
            zIndex: 1,
          }}
        >
          {/* Floating icon with pulse ring */}
          <div className="qs-fade-up-1" style={{ position: "relative", marginBottom: 36 }}>
            {/* Pulse rings */}
            <div
              className="qs-pulse-ring"
              style={{
                position: "absolute",
                inset: -20,
                borderRadius: "50%",
                border: "1px solid rgba(229,35,36,0.4)",
              }}
            />
            <div
              className="qs-pulse-ring"
              style={{
                position: "absolute",
                inset: -20,
                borderRadius: "50%",
                border: "1px solid rgba(229,35,36,0.25)",
                animationDelay: "0.6s",
              }}
            />

            {/* Icon container */}
            <div
              className="qs-float"
              style={{
                width: 100,
                height: 100,
                borderRadius: 24,
                background:
                  "linear-gradient(135deg, rgba(229,35,36,0.15) 0%, rgba(229,35,36,0.05) 100%)",
                border: "1px solid rgba(229,35,36,0.25)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 0 40px rgba(229,35,36,0.15), inset 0 1px 0 rgba(255,255,255,0.05)",
              }}
            >
              <QRIcon />
            </div>
          </div>

          {/* Badge */}
          <div className="qs-fade-up-1 qs-badge" style={{ marginBottom: 20 }}>
            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 6,
                padding: "5px 14px",
                borderRadius: 999,
                background: "rgba(229,35,36,0.1)",
                border: "1px solid rgba(229,35,36,0.2)",
                fontSize: 11,
                fontWeight: 700,
                color: "#E52324",
                letterSpacing: "0.08em",
                textTransform: "uppercase",
                cursor: "default",
              }}
            >
              <span style={{ width: 6, height: 6, borderRadius: "50%", background: "#E52324", display: "inline-block" }} />
              {pageTitle}
            </span>
          </div>

          {/* Heading */}
          <h1
            className="qs-fade-up-2 qs-shimmer-text"
            style={{
              fontSize: "clamp(36px, 6vw, 58px)",
              fontWeight: 900,
              fontFamily: "'Outfit', sans-serif",
              lineHeight: 1.1,
              marginBottom: 16,
              letterSpacing: "-0.02em",
            }}
          >
            Coming Soon
          </h1>

          {/* Sub-text */}
          <p
            className="qs-fade-up-3"
            style={{
              fontSize: 15,
              color: "rgba(255,255,255,0.38)",
              lineHeight: 1.7,
              maxWidth: 440,
              marginBottom: 40,
            }}
          >
            We're crafting something amazing for{" "}
            <span style={{ color: "rgba(255,255,255,0.65)", fontWeight: 600 }}>{pageTitle}</span>.
            Stay tuned — this feature will be live very soon.
          </p>

          {/* Animated dots */}
          <div
            className="qs-fade-up-3"
            style={{ display: "flex", gap: 8, marginBottom: 44 }}
          >
            {[0, 1, 2].map(i => (
              <span
                key={i}
                className="qs-dot"
                style={{
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  background: "#E52324",
                  display: "inline-block",
                  animationDelay: `${i * 0.2}s`,
                }}
              />
            ))}
          </div>

          {/* CTA Button */}
          <div className="qs-fade-up-4">
            <Link
              to="/qr-studio"
              className="qs-btn"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 8,
                padding: "14px 32px",
                borderRadius: 16,
                background: "linear-gradient(135deg, #E52324 0%, #C41E1E 100%)",
                color: "#fff",
                fontSize: 13,
                fontWeight: 800,
                textDecoration: "none",
                boxShadow: "0 8px 32px rgba(229,35,36,0.3)",
                letterSpacing: "0.01em",
              }}
            >
              ← Back to QR Studio
            </Link>
          </div>
        </main>
      </div>
    </>
  );
}
